import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import MappingListComponent from './mappingList.component';
import MappingUploadContainer from '../../upload/mappingUpload.container';
import MappingClearContainer from './mappingClear.container';
import Typography from '@material-ui/core/Typography';

const MappingComponent = ({ metadata }) => (
  <React.Fragment>
    <div style={{ padding: '25px 0 0 25px' }}>
      <Typography variant="h4" gutterBottom>Mapping</Typography>
    </div>
    <MappingListComponent metadata={metadata} />
    <MappingClearContainer disabled={!_.some(metadata, column => column.mapped)} />
    <MappingUploadContainer />
  </React.Fragment>
);

MappingComponent.propTypes = {
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    mapped: PropTypes.bool,
  }).isRequired,
};

export default MappingComponent;
